import styled from 'styled-components/macro';

type Props = {
  address: string;
};

export const AddressBox = ({ address }: Props) => {
  return (
    <AddressContainer>
      {address.split(',').map(addressLine => (
        <AddressLine key={addressLine}>{addressLine}</AddressLine>
      ))}
    </AddressContainer>
  );
};

const LINE_HEIGHT = 24;

const AddressContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  text-transform: uppercase;
  height: ${4 * LINE_HEIGHT}px;
`;

const AddressLine = styled.p`
  margin: 0;
  font-size: ${LINE_HEIGHT * 0.8}px;
  height: ${LINE_HEIGHT}px;
`;
